import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AuthenticatedRoute from "./components/AuthenticatedRoute/AuthenticatedRoute";
import { useMainRoutes } from "./hooks/useMainRoutes";
import useScopedRoutes from "./hooks/useScopedRoutes";
import AuthLayout from "./layouts/AuthLayout/AuthLayout";
import MainLayout from "./layouts/MainLayout/MainLayout";
import { authRoutes } from "./routes/auth-routes";

import { publicRoutes } from "./routes/public-routes";

function App() {
  const { search } = useLocation();
  const { mainRoutes: scopedMainRoutes, defaultRedirectUrl } = useMainRoutes();

  const { routes: scopedPublicRoutes } = useScopedRoutes(publicRoutes);

  const { routes: scopedAuthRoutes } = useScopedRoutes(authRoutes);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <AuthenticatedRoute>
            <MainLayout />
          </AuthenticatedRoute>
        }
      >
        <Route index element={<Navigate to={defaultRedirectUrl + search} />} />
        {scopedMainRoutes.map((r) => (
          <Route
            key={r.id}
            path={r.path}
            index={r.index}
            element={r.component}
          />
        ))}
      </Route>
      <Route path="/" element={<AuthLayout />}>
        {scopedPublicRoutes.map((r) => (
          <Route
            key={r.id}
            path={r.path}
            index={r.index}
            element={r.component}
          />
        ))}
      </Route>
      <Route path="auth" element={<AuthLayout />}>
        {scopedAuthRoutes.map((r) => (
          <Route
            key={r.id}
            path={r.path}
            index={r.index}
            element={r.component}
          />
        ))}
      </Route>
    </Routes>
  );
}

export default App;
